import { render } from "./IssueArticleHeader.vue?vue&type=template&id=0ae578a4&scoped=true"
import script from "./IssueArticleHeader.vue?vue&type=script&lang=js"
export * from "./IssueArticleHeader.vue?vue&type=script&lang=js"

import "./IssueArticleHeader.vue?vue&type=style&index=0&id=0ae578a4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src818063794/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae578a4"]])

export default __exports__